import { getViewDataOutDto } from '../dto/viewData.dto';
import { getViewDataApi } from '../viewData';
export function getViewDataImpl(inData) {
    return getViewDataApi(inData).then(data => {
        return getViewDataOutDto(data);
    });
}
